// extracted by mini-css-extract-plugin
export var actionButton = "_80-1";
export var actionButtons = "_80-2";
export var actions = "_80-0";
export var aiUnread = "_80-10";
export var alignCenter = "_80-h";
export var backWrapper = "_80-3";
export var cellContainer = "_80-4";
export var checkboxContainer = "_80-5";
export var contentContainer = "_80-6";
export var contentHeader = "_80-8";
export var conversationsTableWrapper = "_80-s";
export var draftReplyBadgeContainer = "_80-m";
export var dropdownItem = "_80-b";
export var dropdownItemsContainer = "_80-a";
export var dropdownTitle = "_80-c";
export var errorIcon = "_80-7";
export var filter = "_80-d";
export var gray = "_80-i";
export var headerActionButtons = "_80-e";
export var headerCheckboxContainer = "_80-f";
export var icon = "_80-j";
export var menuContainer = "_80-k";
export var noMoreTicketsIcon = "_80-12";
export var noMoreTicketsSubText = "_80-13";
export var oneLine = "_80-l";
export var optionsButton = "_80-n";
export var plus = "_80-o";
export var portalButtonsWrapper = "_80-g";
export var red = "_80-p";
export var scrolledTop = "_80-9";
export var search = "_80-q";
export var selectedConversationsCount = "_80-r";
export var spinner = "_80-t";
export var strong = "_80-u";
export var summaryCell = "_80-v";
export var tableContainer = "_80-11";
export var tagContainer = "_80-w";
export var threeDots = "_80-x";
export var twoLines = "_80-y";
export var unread = "_80-z";